import axios from 'axios'

export const instance = axios.create({
    baseURL: "https://apimonitoreo.vspamazonas.com.co/",
    withCredentials: true
})

export default instance